import React from 'react';

function ResetIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g transform="translate(-208 -1240)">
                    <g transform="translate(208 1240)">
                        <path
                            fill="currentColor"
                            d="M12.022 0a11.96 11.96 0 018.267 3.323l1.729-1.728C22.749.864 24 1.382 24 2.417v6.486c0 .642-.52 1.162-1.161 1.162h-6.487c-1.035 0-1.553-1.251-.821-1.983l2.02-2.02a8.07 8.07 0 00-5.479-2.19c-4.47-.04-8.24 3.579-8.2 8.198C3.907 16.452 7.46 20.13 12 20.13c1.99 0 3.87-.71 5.353-2.01a.58.58 0 01.792.026l1.92 1.92a.582.582 0 01-.024.843A11.956 11.956 0 0112 24C5.373 24 0 18.627 0 12 0 5.38 5.402-.012 12.022 0z"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default ResetIcon;
